import { EventEmitter } from 'events';

export const WEBCAST_SIDEBAR_NOTIFICATION_EVENT = 'webcastNotificationChanged';

export class SidebarNotification extends EventEmitter {
	public showIcon = false;
	private _enabled = true;
	private _notificationCount = 0;

	public get enabled(): boolean {
		return this._enabled;
	}

	public set enabled(isEnabled: boolean) {
		this._enabled = !!isEnabled;

		if (!this._enabled) {
			this.clear();
		}
	}

	public get count(): number {
		return this._notificationCount;
	}

	public clear(): void {
		this.showIcon = false;
		this._notificationCount = 0;
		this.emit(WEBCAST_SIDEBAR_NOTIFICATION_EVENT);
	}

	public setIcon(): void {
		if (this.enabled) {
			this.showIcon = true;
			this.emit(WEBCAST_SIDEBAR_NOTIFICATION_EVENT);
		}
	}

	public addNotification(): void {
		if (this.enabled) {
			++this._notificationCount;
			this.emit(WEBCAST_SIDEBAR_NOTIFICATION_EVENT);
		}
	}
}
